export default {
  GET_ITEMS(state) {
    return state.avis
  },

  GET_ITEM(state, id) {
    return state.avis.find(item => item.id == id)
  },
}
